import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, TouchableOpacity, TextInput } from "react-native";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";

import {
  FontAwesome,
  Feather,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

export default class Note extends React.Component {
  static propTypes = {
    children: PropTypes.string.isRequired,
    style: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded || false,
    };
  }

  render() {
    let { style } = this.props;

    return (
      <View style={[styles.wrapper, style]}>
        {this.renderText()}
        {this.renderButton()}
      </View>
    );
  }

  renderText = () => {
    let { expanded } = this.state;
    let text = this.props.children;
    if (typeof text == "string") {
      if (text[1] == ":") text = text.substr(2);
    }
    return (
      <Text numberOfLines={expanded ? 999 : 4}>
        <FontAwesome
          name="file-text"
          color={colors.placeholder}
          style={{ marginRight: 10 }}
        />
        {text}
      </Text>
    );
  };

  renderButton = () => {
    let { expanded } = this.state;
    return (
      <TouchableOpacity
        onPress={() => this.setState({ expanded: !expanded })}
        style={styles.button}
      >
        {expanded ? (
          <Feather
            name="chevron-up"
            color={colors.placeholder}
            style={styles.icon}
          />
        ) : (
          <Feather
            name="chevron-down"
            color={colors.placeholder}
            style={styles.icon}
          />
        )}
        {/*<MaterialCommunityIcons
            name="text"
            color={colors.placeholder}
            style={styles.icon}
          />*/}
      </TouchableOpacity>
    );
  };
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    // maxWidth: 250,
    backgroundColor: colors.fill,
    borderRadius: sizes.small,
    padding: sizes.small,
  },
  button: {
    // alignSelf: "flex-start",
    alignSelf: "flex-end",
  },
  icon: {
    // fontSize: 25,/
    // padding: sizes.base,
    ...styleSheet.icon,
    padding: 0,
    paddingHorizontal: sizes.small,
  },
});
